var _path, _path2, _circle, _circle2, _circle3, _circle4, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetricsExportinline = function SvgMetricsExportinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeWidth: 2,
    d: "M10 18a2 2 0 0 1 2-2h56a2 2 0 0 1 2 2v40H10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M22 51V35M34 42l-12-7M46 28 34 42M58 35l-12-7M34 51v-9M46 51V28M58 51V35"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 35,
    r: 3,
    fill: "#FFF5D6",
    stroke: "#FFBF00",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 42,
    r: 3,
    fill: "#D6EBFF",
    stroke: "#0073E6",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 28,
    r: 3,
    fill: "#FBDADA",
    stroke: "#EB4748",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 35,
    r: 3,
    fill: "#D6FFFC",
    stroke: "#00877C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A7B1BE",
    strokeWidth: 2,
    d: "M4 59.4A1.4 1.4 0 0 1 5.4 58h69.2a1.4 1.4 0 0 1 1.4 1.4 5.6 5.6 0 0 1-5.6 5.6H9.6A5.6 5.6 0 0 1 4 59.4Z"
  })));
};
export default SvgMetricsExportinline;